import { useState } from 'react';
import { Card, Text, Badge, Progress, Group, Stack, Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const VENDOR_COLOR = { aws: '#e8590c', microsoft: '#1c7ed6', google: '#34A853' };
const VENDOR_LABEL = { aws: 'AWS', microsoft: 'Microsoft', google: 'Google' };

const STATUS_META = {
  enrolled:  { label: 'Enrolled',  color: 'violet' },
  learning:  { label: 'Learning',  color: 'blue'   },
  certified: { label: 'Certified', color: 'green'  },
  retired:   { label: 'Retired',   color: 'gray'   },
};

function QualificationCard({ exam, progress }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const vendorKey = exam.vendor?.toLowerCase() ?? '';

  const statusMeta = STATUS_META[exam.status] ?? null;

  const total      = progress?.total      ?? 0;
  const correct    = progress?.correct    ?? 0;
  const incorrect  = progress?.incorrect  ?? 0;
  const excluded   = progress?.excluded   ?? 0;
  const unanswered = total - correct - incorrect - excluded;
  const pct = (n) => (total > 0 ? Math.round((n / total) * 100) : 0);

  return (
    <Card
      padding="lg"
      style={{
        cursor: 'pointer',
        boxShadow: hovered ? '0 0 0 2px #c96442' : 'none',
        transition: 'box-shadow 0.15s ease',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => navigate(`/Study/${exam.code}`)}
    >
      <Stack gap="xs">
        {/* ベンダーバッジ（左上） + ステータスバッジ（右上） */}
        <Group justify="space-between" align="center">
          <Badge
            color={VENDOR_COLOR[vendorKey] ?? 'gray'}
            variant="filled"
            size="sm"
            style={{ textTransform: 'none' }}
          >
            {VENDOR_LABEL[vendorKey] ?? exam.vendor}
          </Badge>

          {statusMeta && (
            <Badge
              color={statusMeta.color}
              variant="filled"
              size="sm"
              style={{ textTransform: 'none' }}
            >
              {statusMeta.label}
            </Badge>
          )}
        </Group>

        {/* 正式名称 */}
        {exam.formal_name && (
          <Text ff='"Lora", Georgia, serif' size="md" fw={500} lh={1.3}>
            {exam.formal_name}
          </Text>
        )}

        {/* 略称 */}
        <Text size="xs" c="dimmed" lh={1.3}>
          {exam.name}
        </Text>

        {/* 進捗バー */}
        {total > 0 ? (
          <>
            <Box mt="xs">
              <Progress.Root size="md" radius="sm">
                <Progress.Section value={pct(correct)}   color="teal"   />
                <Progress.Section value={pct(incorrect)} color="red"    />
                <Progress.Section value={pct(excluded)}  color="yellow" />
              </Progress.Root>
            </Box>
            <Group gap="sm" wrap="wrap">
              <Text size="xs" c="teal"  fw={600}>正解 {correct}</Text>
              <Text size="xs" c="red"   fw={600}>不正解 {incorrect}</Text>
              <Text size="xs" c="dimmed">未回答 {unanswered}</Text>
            </Group>
            <Text size="xs" c="dimmed">全 {total} 問</Text>
          </>
        ) : (
          <Text size="xs" c="dimmed" mt="xs">問題データなし</Text>
        )}
      </Stack>
    </Card>
  );
}

export default QualificationCard;
